import { DeleteOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, Divider, Flex, Select, Table } from 'antd'
import { TableColumnsType } from 'antd/lib'
import { useMemo, useState } from 'react'

import { PageBreadcrumbs, TableActionButtons } from 'src/components'
import { useTablePagination } from 'src/hooks'
import { useLocales } from 'src/locales'

import { AddPeopleModal } from '../components'
import { data } from '../data'

export const SupportInvestigation = () => {
  const { t } = useLocales()
  const pagination = useTablePagination()
  const [currentId, setCurrentId] = useState<number>()

  const getActionItems = useMemo(
    () => (id: number) => [
      {
        key: 'add',
        label: t('support_investigation.add_people'),
        icon: <PlusOutlined />,
        onClick: () => setCurrentId(id)
      },
      {
        key: 'delete',
        label: t('support_investigation.delete_org'),
        icon: <DeleteOutlined />,
        danger: true,
        onClick: () => alert(id)
      }
    ],
    [t]
  )

  const columns = useMemo(
    (): TableColumnsType => [
      {
        key: 'name',
        title: t('support_investigation.org_name'),
        dataIndex: 'name'
      },
      {
        key: 'data',
        title: t('common.date'),
        dataIndex: 'date'
      },
      {
        key: 'people count',
        title: t('support_investigation.people_count'),
        dataIndex: 'people_count'
      },
      {
        key: 'action',
        render: ({ id }) => <TableActionButtons items={getActionItems(id)} />
      }
    ],
    [t]
  )

  return (
    <PageBreadcrumbs
      title={t('menu.support_investigation')}
      items={[{ title: t('menu.support_investigation') }]}
    >
      <Flex justify="space-between">
        <Select placeholder={t('support_investigation.select_placeholder')} />

        <Button type="primary" icon={<PlusOutlined />}>
          {t('support_investigation.add_org')}
        </Button>
      </Flex>

      <Divider />

      <Table
        rowKey="id"
        columns={columns}
        dataSource={data}
        scroll={{ x: 'max-content' }}
        pagination={{ ...pagination, total: data.length }}
      />

      {currentId && (
        <AddPeopleModal
          id={currentId}
          onCancel={() => setCurrentId(undefined)}
        />
      )}
    </PageBreadcrumbs>
  )
}
